/** Search key: "Đèn bàn" and "den ban" match. No case, no Vietnamese tone marks, đ → d. */
export function fold(s: string): string {
  return s.normalize('NFD').replace(/\p{M}/gu, '').replace(/[đĐ]/g, 'd').toLowerCase().trim();
}
